module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 044.d647f7ba.jpg";